<template>
  <div>
    <location-special-schedule-item
      v-for="(item, key) in items"
      :key="item.key"
      :options="scheduleOptions"
      v-bind:value="item"
      v-on:change="val => updateData(val, key)"
      v-on:remove="removeAll(key)"
      :limit="3"
    />

    <v-btn
      v-if="items.length < limit"
      small
      color="primary"
      text
      class="mb-3"
      @click="addNewLine"
    >
      {{ addText }}
    </v-btn>
  </div>
</template>

<script>
import LocationSpecialScheduleItem from '@/views/Locations/Components/LocationSpecialScheduleItem'

export default {
  components: {
    LocationSpecialScheduleItem
  },
  name: "LocationSpecialScheduleList",
  props: {
    limit: {
      type: Number,
      required: true
    },
    value: Array,
    addText: {
      type: String,
      default: 'Adicionar'
    },
  },
  data: () => ({
    scheduleOptions: [],
    itemSelected: '',
    open: true,
    items: [{
      open_time: '',
      close_time: ''
    }]
  }),
  methods: {
    change: function() {
      this.$emit('change', this.items)
    },
    addNewLine: function() {
      if (this.items.length < this.limit) {
        this.items.push([
            {open_time: '', close_time: '', start_date: '', end_date: '', is_closed: false, is_24_hours: false}
        ])
        this.change()
      }
    },
    removeAll: function(key) {
      if (this.items.length > 0) {
        this.items.splice(key, 1)
        this.change()
      }
    },
    updateData: function(value, key) {
      this.items[key] = value
      this.change()
    },
    generateOptions: function() {
      const options = []
      for (let i = 0; i <= 24; i++) {
        options.push(`${i < 10 ? '0'+i : i}:00`)
        if (i < 24) options.push(`${i < 10 ? '0'+i : i}:30`)
      }
      return options
    },
    parseAndSetData: function() {
      if (this.value) {
        let newData = []
        const data = JSON.parse(JSON.stringify(this.value)) // Cria uma cópia do objeto
        if (data) {
          for (const d in data) {
            newData.push(data[d])
          }
        }
        this.items = newData
      }
    }
  },
  created() {
    this.scheduleOptions = this.generateOptions()
    this.parseAndSetData()
  },
  watch: {
    itemSelected: function(val) {
      this.items.map((item, index) => {
        item.selected = index === val
        return item
      })
      this.change()
    },
    value: function () {
      this.parseAndSetData()
    },
    items: function (value) {
      this.items = value
    },
  }
}
</script>

<style scoped>
.action-cols {
  min-width: 56px
}
</style>